module.exports = __webpack_public_path__ + "img/image_content.97d6f960.png";